import { useState } from "react";
import "./TabsSection.css";

import tab1 from "../../assets/image/tabs-img/01.svg";
import tab2 from "../../assets/image/tabs-img/02.svg";
import tab3 from "../../assets/image/tabs-img/03.svg";
import tab4 from "../../assets/image/tabs-img/04.svg";
import tab5 from "../../assets/image/tabs-img/05.svg";
import tab6 from "../../assets/image/tabs-img/06.svg";
import tab7 from "../../assets/image/tabs-img/07.svg";
import tab8 from "../../assets/image/tabs-img/08.svg";

// CARD IMAGES
import img1 from "../../assets/image/switechs/01.webp";
import img2 from "../../assets/image/switechs/02.webp";
import img3 from "../../assets/image/switechs/03.webp";
import img4 from "../../assets/image/switechs/04.webp";

const TabsSection = () => {
  const [activeTab, setActiveTab] = useState("optical");

  const tabs = [
    { id: "switches", label: "Switches", icon: tab1 },
    { id: "networking", label: "Networking", icon: tab2 },
    { id: "optical", label: "Optical Transceivers", icon: tab3 },
    { id: "cables", label: "Fiber Optic Cables", icon: tab4 },
    { id: "racks", label: "Panels, Enclosures & Racks", icon: tab5 },
    { id: "optical-networking", label: "Optical Networking", icon: tab6 },
    { id: "systems", label: "Copper Systems", icon: tab7 },
    { id: "tools", label: "Testers & Tools", icon: tab8 },
  ];

  const cards = [
    {
      title: "Enterprise Switches",
      img: img1,
      items: [
        "1/2.5G Enterprise Switches",
        "10G Enterprise Switches",
        "25G Enterprise Switches",
        "40G Enterprise Switches",
        "100G Enterprise Switches",
      ],
    },
    {
      title: "Data Center Switches",
      img: img2,
      items: [
        "10/25G Data Center Switches",
        "100G Data Center Switches",
        "400G Data Center Switches",
        "Modular Data Center Switches",
        "NVIDIA® Switches",
      ],
    },
    {
      title: "PoE+ Switches",
      img: img3,
      items: [
        "1G PoE+ Switches",
        "2.5/5G PoE+ Switches",
        "10G PoE++ Switches",
        "Switch Accessories",
      ],
    },
    {
      title: "Industrial Switches",
      img: img4,
      items: [
        "DIN Rail Mount Industrial Switches",
        "Rack Mount Industrial Switches",
        "Wall Mount Industrial Switches",
        "PoE Industrial Switches",
        "Industrial Cellular Gateway",
      ],
    },
  ];

  return (
    <section className="tabs-wrapper">
      <ul className="nx-tabs-grid">
        {tabs.map(tab => (
          <li
            key={tab.id}
            className={activeTab === tab.id ? "active" : ""}
            onClick={() => setActiveTab(tab.id)}
          >
            <img src={tab.icon} alt={tab.label} />
            <span>{tab.label}</span>
          </li>
        ))}
      </ul>

      <div className="nx-cards-grid">
        {cards.map((card, i) => (
          <div className="nx-card" key={i}>
            <img src={card.img} alt={card.title} />
            <h6>{card.title}</h6>
            <ul>
              {card.items.map((item, j) => (
                <li key={j}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TabsSection;
